<template>
  <div class="refinement-category">
    <div v-show="showTitle" class="title">{{ title || checkboxFilter.label }}</div>
    <div
      v-for="(item, key) in checkboxFilter.items"
      :key="key"
      class="option-select team-member-select"
      :class="{ disabled: checkboxDisabled(item.counter) }"
    >
      <visual-input
        :input-id="item.id"
        :name="`${checkboxFilter.name}[]`"
        type="checkbox"
        :initial-value="item.state"
        unchecked-value=""
        :label="accessibilityLabel(item)"
        :disabled="checkboxDisabled(item.counter)"
        :checked="isChecked(item.state)"
        @change="checkboxChange(item)"
      >
        <div class="select-toggle">
          <i
            v-if="checkboxDisabled(item.counter)"
            class="material-symbols-outlined fill"
            aria-hidden="true"
            data-icon="indeterminate_check_box"
          ></i>
          <i
            v-else-if="item.state === 'include'"
            class="material-symbols-outlined fill selected"
            aria-hidden="true"
            data-icon="check_box"
          ></i>
          <i
            v-else-if="item.state === 'exclude'"
            class="material-symbols-outlined fill excluded"
            aria-hidden="true"
            data-icon="disabled_by_default"
          ></i>
          <i
            v-else
            class="material-symbols-outlined fill"
            aria-hidden="true"
            data-icon="check_box_outline_blank"
          ></i>
        </div>
        <div class="name">
          {{ item.label }}
        </div>
        <div class="avatar">
          <img :src="item.thumbnail" :alt="`${item.label} profile image`" />
        </div>
      </visual-input>
      <div class="option-count">
        {{ enableFacets ? item.counter : '' }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Standard and Tri-state checkbox filters for team members
 */
import { useTriStateCheckboxFilter } from '@/composables/tri-state-checkbox-filter'
import VisualInput from '@/components/forms/visual-input.vue'
import type { CheckboxFilter } from '@/types/search-types'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    checkboxFilter: CheckboxFilter
    showTitle?: boolean
    title?: string
    triState?: boolean
  }>(),
  {
    showTitle: true,
    title: '',
    triState: false,
  },
)

/** EMITS **/
const emit = defineEmits(['checkbox-change'])

/** METHODS **/
const { accessibilityLabel, checkboxDisabled, checkboxChange, enableFacets, isChecked } =
  useTriStateCheckboxFilter({
    checkboxFilter: () => props.checkboxFilter,
    triStateEnabled: () => props.triState,
    debounceCallback: (checkboxItems) => {
      emit('checkbox-change', checkboxItems)
    },
  })
</script>
